module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/67.f64e4c69.png";